import { connect } from 'react-redux'
import MaintenanceModifyComponent from '../components/MaintenanceModifyComponent.jsx';
import {
	clean,
	forwardToFindCardDetails,
	forwardToMarkDetailAs,
	forwardToDeleteDetail,
	forwardToFindCard,
	forwardToRefineCardAsDiscardClothes,
	forwardToRefineCardAsDiscardPant,
	forwardToHideAppendDetailModal,
	forwardToShowAppendDetailModal,
	forwardToFindCategories,
	forwardToAssignAppendSet,
	forwardToAssignAppendItem,
	forwardToAssignAppendNote,
	forwardToAppendMaintenanceDetail

} from '../actions';

const mapStateToProps = (state) => ({

	request: state.getIn(['maintenanceRefineReducer', 'request']),
	response: state.getIn(['maintenanceRefineReducer', 'response']),
	options: state.getIn(['maintenanceRefineReducer', 'options']),

	categories: state.getIn(['checkCardReducer', 'view']).get('categories'),
	
	alert: state.getIn(['alertReducer', 'alert']),
	
})

const mapDispatchToProps = (dispatch) => ({
	unmarkCardAsDiscardClothes: (card) => {
		dispatch(forwardToRefineCardAsDiscardClothes(card.id, false));
		clean(dispatch);
		// dispatch(forwardToFindCard(card.id));
	},
	markCardAsDiscardClothes: (card) => {
		dispatch(forwardToRefineCardAsDiscardClothes(card.id, true));
		clean(dispatch);
		// dispatch(forwardToFindCard(card.id));
	},
	unmarkCardAsDiscardPant: (card) => {
		dispatch(forwardToRefineCardAsDiscardPant(card.id, false));
		clean(dispatch);
		// dispatch(forwardToFindCard(card.id));
	},
	markCardAsDiscardPant: (card) => {
		dispatch(forwardToRefineCardAsDiscardPant(card.id,true));
		clean(dispatch);
		// dispatch(forwardToFindCard(card.id));
	},

	findDetails: (cardPk) => {
		dispatch(forwardToFindCardDetails(cardPk));
		clean(dispatch);
	},

	findCard: (cardPk) => {
		dispatch(forwardToFindCard(cardPk));
		clean(dispatch);
	},

	markDetailAsPass: (detailPk, cardPk) => {
		dispatch(forwardToMarkDetailAs("PASS",detailPk, cardPk));
		clean(dispatch);
	},
	markDetailAsRemoved: (detailPk, cardPk, remover) => {
		dispatch(forwardToMarkDetailAs("REMOVED",detailPk, cardPk, remover));
		clean(dispatch);
	},
	deleteDetail: (detailPk, cardPk) => {
		dispatch(forwardToDeleteDetail(detailPk, cardPk));
		clean(dispatch);
	},

	showAppendModal: (card, category) => {
		dispatch(forwardToShowAppendDetailModal(card, category));
		clean(dispatch);
	},

	assignAppendSet:( checkSet )=>{
		dispatch(forwardToAssignAppendSet(checkSet));
		clean(dispatch);
	},

	assignAppendItem:( checkItem )=>{
		clean(dispatch);
		dispatch(forwardToAssignAppendItem(checkItem));
	},

	assignAppendNote:( note )=>{
		clean(dispatch);
		dispatch(forwardToAssignAppendNote(note));
	},

	hideAddModal: () => {
		clean(dispatch);
		dispatch(forwardToHideAppendDetailModal());
	},

	findCategories: () => {
		clean(dispatch);
		dispatch(forwardToFindCategories())
	},

	appendCheckDetail: (editing) => {
		clean(dispatch);
		dispatch(forwardToAppendMaintenanceDetail(editing))
	},
})

const MaintenanceModifyContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceModifyComponent)

export default MaintenanceModifyContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceModifyContainer.jsx